export const CLEAR_UI_FORM_ELEMENTS = 'fulcrum/containers/UiState/CLEAR_UI_STATE'
